import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthentificationService} from './authentification.service';

@Component({
    selector: 'users',
    styleUrls: ['./styles/users.component.css'],
    templateUrl: './templates/users.component.html',
    providers: [AuthentificationService]
})


export class UsersComponent {
    name = 'Users';

    constructor(private authentification_service: AuthentificationService, private router: Router) {
        this.CheckUSerSession();
    }

    CheckUSerSession(): void {
        this.authentification_service.UserCheckSession().then(result => {if (result['id_user'] === 0) {this.router.navigate(['authentification'])} });
    }

    ngOnInit(): void {

    }

}






// WEBPACK FOOTER //
// ./src/app/users.component.ts